import { EmptyDalgu } from '../../../images/icons/icons_component'

const PopupDataGrid = ({ dataHead, dataColumn, dataList, flag}) => {
    
    const borderColorGray = flag === 'ptmi' ? 'st_border_soft' : flag === 'trms' ? 'tr_border_soft' : 'ho_border_soft';
    const lightBackColor = flag === 'ptmi' ? 'bg_st_odd' : flag === 'trms' ? 'bg_tr_odd' : 'bg_ho_odd';
    
    return (
        <div className='data_grid_container'>
            <div className='popup_font'>
                <hr className={`border-t-2 mr-1-1 ${borderColorGray}`}/>
                <div className='data_list_table grid-animation' style={{ maxHeight: '25rem' }}>
                    <table>
                        <thead>
                            <tr>
                                <th>번호</th>
                                {dataHead.map((content, index) => (
                                    <th key={index}>
                                        {content}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {!dataList || dataList.length === 0 ? (
                                <tr>
                                    <td colSpan={1000} className='empty_box'>
                                        <span className={`data_empty ${lightBackColor}`}>
                                            <EmptyDalgu /> 해당하는 데이터가 없습니다.
                                        </span>
                                    </td>
                                </tr>
                            ) : (
                                dataList.map((item, index) => {
                                    const gridColor = index % 2 === 0 ? lightBackColor : '';
                                    return (<tr key={index} className={gridColor}>
                                        <td>{index + 1}</td>
                                        {dataColumn.map((idx, index) => (
                                            <td key={index}>{item[idx]}</td>
                                        ))}
                                    </tr>
                                    )
                                })
                            )}
                        </tbody>
                    </table>
                </div>
                <hr className='mr-1-1 co_border_gray'/>
            </div>
        </div>
    );
};

export default PopupDataGrid;